import React, { useContext } from "react";
import { VariantContextData } from "./VariantBuilderContext";
import {
  flexColumnLayoutPresets,
  flexPresetMatchingWidths,
  getLiveFlexSectionColumns,
  flexWidthResetUpdates,
} from "../../utils/builderUtils";

const VariantBuilderSettingFlexColumnLayout = (props) => {
  const [, builder] = useContext(VariantContextData);
  const section = props.section;
  const variant = props.variant;

  const isMobile = props.device === "mobile";
  const widthKey = isMobile ? "width-mobile" : "width";
  const perRowKey = isMobile ? "columns-per-row-mobile" : "columns-per-row";

  const columns = getLiveFlexSectionColumns(section, variant);
  const count = columns.length;
  const presets = flexColumnLayoutPresets(count);
  const disabled = presets.length === 0;

  const displayPresets = disabled
    ? flexColumnLayoutPresets(count > 6 ? 6 : 2)
    : presets;

  const currentWidths = columns.map(
    (column) => column.options && column.options[widthKey]
  );
  const activeKey = disabled ? null : flexPresetMatchingWidths(currentWidths);

  const applyPreset = (preset) => {
    if (disabled) return;

    const updates = flexWidthResetUpdates(
      columns,
      widthKey,
      (column, index) => `${preset.values[index]}%`
    );

    updates.push({
      object_type: "sections",
      object_id: section.id,
      setting_name: `[options][structure][${perRowKey}]`,
      value: String(preset.perRow),
    });

    builder.update(updates);
  };

  return (
    <div
      className="column-select-outer"
      style={disabled ? { opacity: 0.5, pointerEvents: "none" } : undefined}
    >
      <div className="row hard-center">
        {displayPresets.map((preset) => {
          const isActive = preset.key === activeKey;
          return (
            <div
              className="col-xs-6"
              key={preset.key}
              style={{ marginBottom: "8px", padding: "0px" }}
            >
              <button
                type="button"
                disabled={disabled}
                className={`btn btn-default column-select-button${
                  isActive ? " column-select-button-active" : ""
                }`}
                onClick={() => applyPreset(preset)}
              >
                <div
                  className="row hard-center"
                  style={{ display: "flex", gap: "2px" }}
                >
                  {(preset.preview || preset.values).map((value, i) => (
                    <div
                      key={i}
                      className="column-value"
                      style={{ width: `${value}%` }}
                    >
                      <div className="row hard-center column-select-option"></div>
                    </div>
                  ))}
                </div>
                <div className="col-xs-12 text-center text-lg column-value">
                  {preset.label}
                </div>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VariantBuilderSettingFlexColumnLayout;
